module.exports = __webpack_public_path__ + "static/media/end-call.6cf20143.svg";